import cloneDeep from 'lodash.clonedeep';
const addPosnToTargetings = (banner, targetings, i) => {
  const bannerCopy = cloneDeep(banner);
  const posn = `posn=${i + 1}`;
  const updatedTargetings = targetings ? `${targetings},${posn}` : posn;
  bannerCopy.settings.targetings = updatedTargetings;
  return bannerCopy;
};
const insertRepeatedBannersWhenIntervalHasComma = (items, positions, banner) => {
  let count = 0;
  const sortedPositions = positions.sort();
  const occurences = sortedPositions.reduce((acc, sortedPosition) => {
    acc[sortedPosition] = 0;
    return acc;
  }, {});
  for (let i = 0; i < items.length + 1; i += 1) {
    let bannerInserted = false;
    const updatedValue = i - count;
    // eslint-disable-next-line no-loop-func
    sortedPositions.forEach(sortedPosition => {
      const parsedPosition = Number(sortedPosition);
      if (i >= parsedPosition && updatedValue % parsedPosition === 0 && updatedValue / parsedPosition === occurences[sortedPosition] + 1) {
        occurences[sortedPosition] += 1;
        if (!bannerInserted) {
          const {
            targetings
          } = banner.settings;
          const updatedBanner = addPosnToTargetings(banner, targetings, count);
          items.splice(i, 0, updatedBanner);
          bannerInserted = true;
          count += 1;
        }
      }
    });
  }
};
const parseInterval = interval => interval ? interval.replace(/ /g, '') : '';
const insertBanners = (items, index, banner) => {
  const itemsCopy = items.slice();
  itemsCopy.splice(index, 1);
  const {
    settings: {
      interval = '',
      repeat = false,
      targetings
    }
  } = banner;
  const parsedInterval = parseInterval(interval);
  const intervalHasComma = parsedInterval.includes(',');
  if (!intervalHasComma) {
    const numericInterval = Number(parsedInterval);
    if (repeat) {
      const childLength = itemsCopy.length;
      for (let i = 0; i < Math.floor(childLength / numericInterval); i += 1) {
        const updatedBanner = addPosnToTargetings(banner, targetings, i);
        itemsCopy.splice(numericInterval * (i + 1) + i, 0, updatedBanner);
      }
    } else {
      const updatedBanner = addPosnToTargetings(banner, targetings, 0);
      itemsCopy.splice(numericInterval, 0, updatedBanner);
    }
  }
  if (intervalHasComma) {
    const positions = parsedInterval.split(',');
    if (repeat) {
      insertRepeatedBannersWhenIntervalHasComma(itemsCopy, positions, banner);
    } else {
      positions.forEach((position, i) => {
        const parsedPosition = Number(position);
        const updatedBanner = addPosnToTargetings(banner, targetings, i);
        if (parsedPosition + i < itemsCopy.length) {
          itemsCopy.splice(parsedPosition + i, 0, updatedBanner);
        }
        if (itemsCopy.length === 1 && parsedPosition === 1) {
          itemsCopy.splice(parsedPosition + i, 0, updatedBanner);
        }
      });
    }
  }
  return itemsCopy;
};
export default insertBanners;
//# sourceMappingURL=insert-banners.js.map